import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import moment from "moment-timezone";
import { DateRangePicker } from 'react-bootstrap-daterangepicker';

import { Application } from '../../models/interfaces';
import Message from '../../components/ui/Message';
import { ApplicationsContext } from '../../context/applications/ApplicationContext';
import { AuthContext } from '../../context/auth';
import ResultModal from './ResultModal';


export const ReportOnboardingPage = () => {

    const navigate = useNavigate();

    const { applications, loadApplications, isLoading, approveRequest, rejectRequest, deleteRequest, getReport, getResponse } = useContext(ApplicationsContext);

    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [approveMessage, setApproveMessage] = useState('');
    const [rejectMessage, setRejectMessage] = useState('');
    const [currentApp, setCurrentApp] = useState(0);
    const [action, setAction] = useState('reject');

    // 🔎 Filtros
    const [appId, setAppId] = useState<string | ''>('');
    const [ruc, setRuc] = useState('');
    const [businessName, setBusinessName] = useState('');
    const [dateIni, setDateIni] = useState('');
    const [dateEnd, setDateEnd] = useState('');
    const { user } = useContext(AuthContext);

    const [result, setResult] = useState<any>(null);
    const [showModal, setShowModal] = useState(false);
    const [resultData, setResultData] = useState<any>(null);



    useEffect(() => {
        const today = moment().format("YYYY-MM-DD");
        setDateIni(today);
        setDateEnd(today);
        getReport('ALL', "", "", "", today, today);
    }, []);

    const handleFilter = () => {
        getReport(
            'ALL',
            appId,
            ruc,
            businessName,
            dateIni,
            dateEnd
        );
    };

    const getTimeZone = (countryCode: string) => {
        switch (countryCode) {
            case "PAN":
                return "America/Panama";
            case "CRI":
                return "America/Costa_Rica";
            default:
                return "UTC";
        }
    };

    const tz = getTimeZone(user.country?.code ?? "CRI");

    const handleView = (application: Application) => {
        navigate('/report-onboarding/view', { state: { application } });
    };

    const handleApprove = (appId: number) => {
        setCurrentApp(appId);
        setApproveMessage("¿Confirma que desea aprobar este cliente?");
    };

    const handleReject = (appId: number) => {
        setCurrentApp(appId);
        setAction('reject');
        setRejectMessage("¿Confirma que desea devolver este cliente?");
    };

    const handleDecline = (appId: number) => {
        setCurrentApp(appId);
        setAction("decline");
        setRejectMessage("¿Confirma que desea eliminar esta solicitud?");
    };

    const confirmApprove = async () => {
        setApproveMessage('');
        const resp = await approveRequest(currentApp.toString());

        if (resp === 'success') {
            setSuccessMessage("La aprobación se realizó correctamente.");
            handleFilter();
        } else {
            setErrorMessage(resp);
        }
    };

    const rejDecRequest = async (reason: string) => {
        setRejectMessage('');

        let resp;
        if (action === 'reject') {
            resp = await rejectRequest(currentApp.toString(), reason);
        } else {
            resp = await deleteRequest(currentApp.toString(), reason);
        }

        if (resp === 'success') {
            setSuccessMessage(
                action === 'reject'
                    ? "La solicitud se rechazó correctamente."
                    : "La solicitud se eliminó correctamente."
            );
            handleFilter();
        } else {
            setErrorMessage(resp);
        }
    };

    const handleDetails = async (app) => {

        if (app.STATUS !== "3" && app.STATUS !== "5") {
            setErrorMessage("Los detalles solo están disponibles para solicitudes aprobadas.");
            return;
        }

        const response = await getResponse(app.APP_ID.toString(), "", "", dateIni,
            dateEnd);


        if (!response) {
            setErrorMessage("La solicitud se encuentra en proceso y no hay información disponible por el momento.");
            return
        }

        setResultData(response);
        setShowModal(true);
    };



    return (
        <div className='mt-5 container'>

            {/* 🔎 FILTROS */}
            <div className="row mt-4">

                <div className="col-md-4">
                    <input
                        type="number"
                        className="form-control"
                        placeholder="# Solicitud"
                        value={appId}
                        onChange={(e) => setAppId(e.target.value ? e.target.value : '')}
                    />
                </div>

                <div className="col-md-4">
                    <input
                        className="form-control"
                        placeholder="Número Id Fiscal"
                        value={ruc}
                        onChange={(e) => setRuc(e.target.value)}
                    />
                </div>

                <div className="col-md-4">
                    <input
                        className="form-control"
                        placeholder="Nombre Comercial"
                        value={businessName}
                        onChange={(e) => setBusinessName(e.target.value)}
                    />
                </div>


            </div>
            <div className="row mt-4 mb-2 justify-content-right">
                <div className="col-md-4">
                    <DateRangePicker
                        onCallback={(start, end) => {
                            setDateIni(start.tz(tz).format("YYYY-MM-DD"));
                            setDateEnd(end.tz(tz).format("YYYY-MM-DD"));
                        }}
                        initialSettings={{
                            locale: {
                                cancelLabel: 'Cancelar',
                                applyLabel: 'Aplicar',
                                customRangeLabel: 'Seleccionar fechas'
                            },
                            startDate: moment().tz(tz),
                            minDate: moment().tz(tz).subtract(1, "year"),
                            maxDate: moment().tz(tz)
                        }}
                    >
                        <input type="text" className="form-control" />
                    </DateRangePicker>
                </div>
                <div className="col-md-2">

                    <button
                        className="btn btn-primary w-100"
                        onClick={handleFilter}
                    >
                        Filtrar
                    </button>
                </div>


            </div><hr />

            <br />

            {/* 📋 TABLA */}
            <table className="table table-hover table-striped">
                <thead>
                    <tr>
                        <th># Solicitud</th>
                        <th>Número Id Fiscal</th>
                        <th>Nombre Comercial</th>
                        <th>Estado</th>
                        <th>Creado</th>
                        <th>Creado por</th>
                        <th>Aprobado</th>
                        <th>Aprobado por</th>
                        <th>Detalles</th>
                    </tr>
                </thead>

                <tbody>
                    {
                        applications.length > 0
                            ? applications.map((app: Application) => (
                                <tr key={app.APP_ID}>
                                    <td>{app.APP_ID}</td>
                                    <td>{app.MERCHANT_RUC}</td>
                                    <td>{app.BUSINESS_NAME}</td>
                                    <td>{getStatus(app)}</td>

                                    <td>
                                        {moment(app.CREATED_AT)
                                            .tz(getTimeZone(user.country.code))
                                            .format('DD/MM/YYYY HH:mm:ss')}
                                    </td>

                                    <td>{app.CREATED_BY}</td>

                                    <td>
                                        {app.CHECKED_AT
                                            ? moment(app.CHECKED_AT)
                                                .tz(getTimeZone(user.country.code))
                                                .format('DD/MM/YYYY HH:mm:ss')
                                            : ""}
                                    </td>

                                    <td>{app.APPROVED_BY ?? ""}</td>

                                    {/* <button type="button" onClick={() => handleDetails(app.response)} className="btn btn-outline-secondary">Ver</button> */}
                                    <td style={{ textAlign: 'center' }}>
                                        <div className="dropdown">
                                            <button
                                                className="btn btn-secondary dropdown-toggle"
                                                type="button"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                <span className='bi bi-list'></span>
                                            </button>

                                            <ul className="dropdown-menu">
                                                <li>
                                                    <button
                                                        className="dropdown-item"
                                                        onClick={() => handleView(app)}
                                                    >
                                                        <i className="bi bi-eye me-2"></i>
                                                        Ver solicitud
                                                    </button>
                                                </li>

                                                <li>
                                                    <button
                                                        className="dropdown-item"
                                                        onClick={() => handleDetails(app)}
                                                    >
                                                        <i className="bi bi-check me-2"></i>
                                                        Datos creados
                                                    </button>
                                                </li>




                                            </ul>
                                        </div>
                                    </td>


                                </tr>
                            ))
                            : (
                                <tr>
                                    <td colSpan={9} className="text-center">
                                        {isLoading ? 'Cargando...' : 'No existen solicitudes.'}
                                    </td>
                                </tr>
                            )
                    }
                </tbody>
            </table>

            {/* MENSAJES */}
            {errorMessage &&
                <Message
                    type="error"
                    message={errorMessage}
                    closeDialog={() => setErrorMessage('')}
                    handleOk={() => setErrorMessage('')}
                />
            }

            {successMessage &&
                <Message
                    type="success"
                    title="Exitoso"
                    message={successMessage}
                    closeDialog={() => setSuccessMessage('')}
                    handleOk={() => setSuccessMessage('')}
                    backgroundColor="rgba(0,0,0,0.4)"
                />
            }

            {approveMessage &&
                <Message
                    type="success"
                    title="Confirmar"
                    message={approveMessage}
                    closeDialog={() => setApproveMessage('')}
                    showCancel={true}
                    handleCancel={() => setApproveMessage('')}
                    handleOk={confirmApprove}
                    okText="Confirmar"
                    backgroundColor="rgba(0,0,0,0.4)"
                />
            }

            {rejectMessage &&
                <Message
                    type="success"
                    title="Confirme"
                    message={rejectMessage}
                    closeDialog={() => setRejectMessage('')}
                    handleOk={rejDecRequest}
                    showReasonField={true}
                    backgroundColor="rgba(0,0,0,0.4)"
                />
            }

            {
                resultData && <ResultModal
                    show={showModal}
                    data={resultData}
                    onClose={() => setShowModal(false)}
                />
            }




        </div>
    );

    function getStatus(app: Application): string {
        switch (app.STATUS) {
            case "1": return "Borrador";
            case "2": return "Pendiente";
            case "3": return "Aprobado";
            case "4": return "Rechazado";
            case "5": return "Procesado con error";
            case "6": return "Eliminada";
            case "7": return "Borrador";
            case "8": return "Rechazado";
            case "9": return "Revision banco";
            default: return "";
        }
    }
};


